import { makeStyles } from '@material-ui/core/styles'
import { Text } from '../../../1elements'
import { ErrorMessage } from 'formik'

const CustomField = ({ item, name, children }) => {
  const classes = useStyles()
  const { label } = item

  return (
    <div className={classes.itemRow}>
      <Text type={'h9'} className={classes.label}>
        {label} :<span>&nbsp;</span>
      </Text>
      <div className={classes.fieldDiv}>
        {children}
        <ErrorMessage name={name} component='div' />
      </div>
    </div>
  )
}

export default CustomField

const useStyles = makeStyles({
  label: {
    whiteSpace: 'nowrap'
  },
  fieldDiv: {
    width: '100%'
  },
  itemRow: {
    display: 'flex',
    alignItems: 'center',
    margin: '5px 0',
    maxWidth: '100%',
    width: '100%'
  }
})
